<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('studnetTopFive.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          { text: $t('studnetTopFive.pageTitle'), active: true }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex">
          <div class="col-md-2">
            <label class="required">{{ $t('studnetTopFive.promotion') }}</label>
            <input
              type="number"
              class="form-control"
              v-model="model.promotion"
            />
            <div class="validate ts-ml-3" v-if="errors.has('promotion')">
              {{ errors.first('promotion') }}
            </div>
          </div>
          <div class="col-md-3">
            <label for="">{{ $t('studnetTopFive.student') }}</label>
            <a-select
              style="width: 100%"
              v-model="model.student_id"
              :options="students"
              :show-search="true"
              :maxTagCount="2"
              :loading="fetching_student"
              :placeholder="$t('all')"
              mode="multiple"
              :filter-option="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
            ></a-select>
          </div>
          <div class="col-md-1 ts-mt-5">
            <ts-button
              class="btn-block"
              color="primary"
              @click.prevent="getData"
              :waiting="waiting"
              >{{ $t('preview') }}</ts-button
            >
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td>{{ record.card_number }}</td>
            <td>{{ record.student_name }}</td>
            <td class="text-center">{{ record.gender }}</td>
            <td class="text-center">{{ record.total_score }}</td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="getData"></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  data () {
    return {
      fetching_student: false,
      waiting: false,
      loading: false,
      students: [],
      errors: new Errors(),
      model: {
        promotion: null,
        student_id: []
      }
    }
  },
  computed: {
    ...mapState('studentTopFive', ['resources', 'pagination']),

    columns () {
      return [
        { name: this.$t('studnetTopFive.cardNumber') },
        { name: this.$t('studnetTopFive.studentName') },
        { name: this.$t('studnetTopFive.gender'), style: 'text-align:center' },
        {
          name: this.$t('studnetTopFive.totalScore'),
          style: 'text-align:center'
        }
      ]
    }
  },
  created () {
    this.getStudent()
    this.getData()
  },
  methods: {
    getStudent () {
      this.errors = new Errors()
      this.$store
        .dispatch('studentTopFive/getStudent', this.model)
        .then(response => {
          this.students = response.data.map(el => ({
            value: el.student_id,
            label: el.full_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching_student = false
        })
    },
    getData (attributes) {
      this.waiting = true
      this.errors = new Errors()
      this.$store
        .dispatch(
          'studentTopFive/getData',
          Object.assign(
            {},
            this.model,

            attributes
          )
        )
        .then(() => {
          this.loading = false
        })
        .finally(() => {
          this.waiting = false
        })
    }
  }
}
</script>
